import Quill from 'quill';

import Popover from '../../popover';
import { ELEMENT_ROLE_SIGN } from '../const';

const InlineEmbed = Quill.import('blots/inline');

const buildTemplate = (payload) => {
  const list = payload?.map(
    (item) => `<li role="${ELEMENT_ROLE_SIGN.errorAdvise}">${item}</li>`,
  );
  return `
    <div class="ts-rich-text__low-error-hint">
      <ul>${list?.join('')}</ul>
    </div>
  `;
};

class LowErrorBlot extends InlineEmbed {
  static create(attrs) {
    const { value, payload, isInsert } = attrs;
    const node = super.create(value);
    // 离谱的bug，如果setContents方法插入的，在加innerText会导致额外多了很多标签和内容，不加inserEmbed又没内容，所以加个isInsert做下区分
    isInsert && (node.innerText = value);
    node.setAttribute('data-payload', payload);
    node.contentEditable = 'true';
    const content = buildTemplate(payload);
    new Popover(node, {
      content,
      placement: 'top',
      align: 'center',
    });
    return node;
  }

  static formats(node) {
    return {
      value: node.innerText,
      payload: node.getAttribute('data-payload')?.split(','),
    };
  }
}

LowErrorBlot.blotName = 'LowErrorEmbed';
LowErrorBlot.className = 'ql-low-error-embed';
LowErrorBlot.tagName = 'span';

export default LowErrorBlot;
